import { combineReducers } from "redux";
import adminCloneProject from "./admin-clone-project/dataSlice";
import adminListProject from "./admin-list-projects/dataSlice";
import cloneProject from "./clone-project/dataSlice";
import deleteProject from "./delete-project/dataSlice";
import listProjects from "./list-projects/dataSlice";

const reducer = combineReducers({
  adminListProject,
  adminCloneProject,
  listProjects,
  deleteProject,
  cloneProject,
});

export default reducer;
